import { createRoute, redirect } from '@tanstack/react-router';
import { Route as pathlessAuthenticatedRoute } from '../route';

// TEMPORARY redirect — remove after all tenants migrate to OMS v3.
// The Discounts v2 page moved to /discounts; stale bookmarks must keep
// working. The v2 page components still live in this folder (imported by the
// /discounts route module).
export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/discounts-v2',
  beforeLoad: () => {
    throw redirect({ to: '/discounts', search: true });
  },
});
